export const isPrerender = userAgent =>
    Boolean(
        userAgent?.includes(
            'Prerender (+https://github.com/prerender/prerender)'
        )
    );
